import React from "react";
import { TbUsers } from "react-icons/tb";

export default function StaffOverview() {
  const stats = [
    { label: "Active", count: 52, percent: "83%", color: "#2ab162ff" },
    { label: "On Leave", count: 8, percent: "13%", color: "#e62e3d" },
    { label: "Inactive", count: 3, percent: "4%", color: "gray" },
  ];

  return (
    <div
      className="overview-col"
      style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 16px #eee",
        padding: "20px 24px",
        marginBottom: "0",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <div>
          <h5 className="h5" style={{ marginTop: 0 }}>
            Staff Overview
          </h5>
          <div style={{ fontSize: "2.2em", fontWeight: "bold" }}>63</div>
          <div style={{ color: "#aaa" }}>Total Staff</div>
        </div>
        <div>
          <TbUsers size={24} />
        </div>
      </div>

      {stats.map(({ label, count, percent, color }, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: index > 0 ? "12px" : undefined,
          }}
        >
          {/* Label with color */}
          <div style={{ color }}>{label}</div>

          <div>
            <strong
              style={{
                border: "1px solid grey",
                padding: "2px 10px",
                borderRadius: "50px",
                marginRight: "8px",
                fontSize: "10px",
              }}
            >
              {count}
            </strong>
            <span style={{ color: "#aaa", fontSize: "12px" }}>{percent}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
